import { CacheKeysModel } from 'utils/types/CacheKeyModel';

export const CacheKeys: CacheKeysModel = {
  authToken: 'persist:auth-token',
  themeColor: 'persist:theme-color',
  businessIds: 'persist:business-ids',
  workspaceIds: 'persist:workspace-ids',
  agentIds: 'persist:agent-ids',
  selectedAgentId: 'persist:selected-agent-id',
  userEmail: 'user-email',
  userStatus: 'user-status'
};
